<template>
  <v-row>
    <v-col cols="12" md="4" offset-md="4">
      <h1 class="text-h1 mt-3">Profil Einstellungen</h1>
    </v-col>
    <v-col>
      <v-row>
        <v-col cols="12" md="4" offset-md="4">
          <ProfileComponent v-model="profileModel" @avatarFileChanged="onAvatarFileChanged"/>
        </v-col>
      </v-row>
      <v-row>
        <pre>
          <code>{{ JSON.stringify(profileModel, null, "\t") }}</code>
        </pre>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ProfileComponent from "@/components/profile/ProfileComponent";
import {reactive} from "@vue/composition-api";

export default {
  name: "ProfileView",
  components: {ProfileComponent},
  setup() {

    const profileModel = reactive([
      {
        title: 'Kontaktdaten',
        editor: {edit: false},
        avatar: {text:'Avatar'},
        fields: [
          {inputValue: 'Mustermann GmbH und Co. KG', type: 'TextFieldCustom', fieldName: 'Firma'},
          {inputValue: 'Herr', type: 'TextFieldCustom', fieldName: 'Anrede'},
          {inputValue: 'Jürgen Malmsheimer', type: 'TextFieldCustom', fieldName: 'Name'},
          {inputValue: 'Zauber Straße 23, Münster 48143, Deutschland', type: 'TextFieldCustom', fieldName: 'Adresse'},
          {inputValue: 'j.malmsheimer@muster.de', type: 'TextFieldCustom', fieldName: 'Email'}
        ]
      },
      {
        title: 'Benachrichtigungen',
        editor: {edit: false},
        fields: []
      },
      {
        title: 'Rechnungsinformationen',
        editor: {edit: false},
        avatar: {text:'Avatar', src: 'https://picsum.photos/91?random=1'},
        fields: [
          {inputValue: 'Lotus & Co. LTD', type: 'TextFieldCustom', fieldName: 'Name'},
          {inputValue: 'Zauber Straße 23, Münster 48143, Deutschland', type: 'TextFieldCustom', fieldName: 'Adresse'},
          {inputValue: 'DE68 2105 0170 0012 3456 78', type: 'TextFieldCustom', fieldName: 'IBAN'},
          {inputValue: 'GENODEF1S04', type: 'TextFieldCustom', fieldName: 'BIC'},
        ]
      },
      {
        title: 'Passworteinstellungen',
        editor: {edit: false},
        fields: []
      }
    ])

    function onAvatarFileChanged(avatar, slot){
      console.log(avatar, slot)
    }
    return {profileModel, onAvatarFileChanged}
  }
}
</script>

<style scoped>

</style>
